export default `require 'openssl'

API_KEY = 'YOUR_API_KEY'

def generate_canny_hash(user_id)
  digest = OpenSSL::Digest.new('sha256')
  hmac = OpenSSL::HMAC.hexdigest(digest, API_KEY, user_id)
  return hmac
end

# Example usage
user_id = "exampleUserID"
hash = generate_canny_hash(user_id)
puts "Generated Hash: #{hash}"
`;
